<h1 mat-dialog-title>{{ 'PRIVACYPOLICY' | translate }}</h1>
<mat-dialog-content [innerHTML]="text"></mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button mat-dialog-close color="accent">{{ 'CLOSE' | translate }}</button>
</mat-dialog-actions>